import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadUserListFailed, loadUserListSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* loadUserList(action) {
  try {
    const url = `${BACKEND_URL}/api/v1/users`;
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK && data && data.data) {
      const body = Array.isArray(data.data) ? data.data : [];
      yield put(loadUserListSuccessful(body));
      yield call(resolveActionPromise(action, body));
    } else {
      yield put(loadUserListFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(loadUserListFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
